import SeoPageList from './SeoPageList.container';

export default SeoPageList;
